// i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import { applyElementLocale } from '../utils/element-locale'

import common from './lang/modules/common'
import earthquake from './lang/modules/earthquake'
import map from './lang/modules/map'
import plate from './lang/modules/plate'

Vue.use(VueI18n)

const LANG_KEY = 'app_lang'
const SUPPORTED = ['zh', 'en']
const FALLBACK_LANG = 'en'

function safeGetStorage(key) {
  try { return localStorage.getItem(key) } catch (e) { return null }
}
function safeSetStorage(key, value) {
  try { localStorage.setItem(key, value) } catch (e) { }
}

export function getConfigDefaultLang() {
  try {
    const cfg = window.CONFIG_JSON || {}
    const lang = cfg.defaultLang
    if (lang && SUPPORTED.indexOf(lang) !== -1) return lang
  } catch (e) { }
  return null
}

function detectBrowserLang() {
  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase()
  if (nav.indexOf('zh') === 0) return 'zh'
  if (nav.indexOf('en') === 0) return 'en'
  return null
}

/**
 * 异步解析初始语言，优先级：
 * 1. localStorage（用户显式切换过，最高优先，避免被浏览器语言拉回）
 * 2. 浏览器语言
 * 3. config.js 首次默认
 * 4. 兜底 en
 *
 * 注：不再调用后端 IP 判定接口。
 */
export async function resolveInitialLang() {
  // 1. 用户之前手动切换过
  const saved = safeGetStorage(LANG_KEY)
  if (saved && SUPPORTED.indexOf(saved) !== -1) return saved

  // 2. 浏览器语言
  const navLang = detectBrowserLang()
  if (navLang) return navLang

  // 3. config.js 默认
  const cfgLang = getConfigDefaultLang()
  if (cfgLang) return cfgLang

  // 4. 兜底
  return FALLBACK_LANG
}

function buildMessages() {
  const zh = {}
  const en = {}
    ;[common, earthquake, map, plate].forEach((m) => {
      if (m.zh) Object.assign(zh, m.zh)
      if (m.en) Object.assign(en, m.en)
    })
  return { zh, en }
}

let _i18n = null

export function createI18n(locale) {
  if (_i18n) return _i18n
  const lang = SUPPORTED.indexOf(locale) !== -1 ? locale : FALLBACK_LANG

  _i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    messages: buildMessages()
  })

  document.documentElement.lang = lang

  try {
    if (typeof applyElementLocale === 'function') {
      applyElementLocale(lang)
    }
  } catch (e) {
    console.warn('[i18n] applyElementLocale failed:', e && e.message)
  }

  return _i18n
}

export function getI18n() {
  return _i18n
}

export function getLang() {
  return _i18n ? _i18n.locale : FALLBACK_LANG
}

// 切换语言：写 localStorage，并由调用方决定是否 reload；同时派发 lang-changed
export function setLang(lang) {
  if (SUPPORTED.indexOf(lang) === -1) return false
  safeSetStorage(LANG_KEY, lang)
  if (_i18n && _i18n.locale !== lang) {
    _i18n.locale = lang
    document.documentElement.lang = lang
    try {
      if (typeof applyElementLocale === 'function') applyElementLocale(lang)
    } catch (e) { }
  }
  // 通知 router 等处刷新 title 等依赖语言的内容
  try {
    window.dispatchEvent(new CustomEvent('lang-changed', { detail: { lang } }))
  } catch (e) { }
  return true
}

export function canSwitchLang() {
  return true
}



// WEBPACK FOOTER //
// ./src/i18n/index.js